import React, {useEffect, useState} from "react";
import { Link, useParams } from "react-router-dom";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExporting from 'highcharts/modules/exporting';
//import Exporting from 'highcharts/modules/exporting';

import { getHviData } from "../../../redux/actions/hvi-data";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const PersonalLinear = (props) => {

    // let seriesName = 'Min HVI';

    // if ( props.type === 'team' ) seriesName = 'Team HVI';

    //console.log( props.summary );

    const { organization_id, team_id } = useParams();
    const dispatch = useDispatch();
    const [hviUpdated, setHviUpdated] = useState(false);
	//const hvidata = useSelector((state) => state.hvidata);

    const [translation] = useTranslation("translations");

    let seriesData = [];

    if ( props.hviValues[0] && props.hviValues[0].length > 0 ) {

        const minHviData = props.hviValues[0].filter( (el) => {
            return el != null;
        });

        if ( minHviData.length > 0 ) {
            seriesData.push(
                {
                    name: translation('my_hvi'),
                    data: props.hviValues[0],
                    color: '#486975'
        
                }
            );
        }
    }

    if ( props.hviValues[1] && props.hviValues[1].length > 0 ) {

        const teamHviData = props.hviValues[1].filter( (el) => {
            return el != null;
        });

        if ( teamHviData.length > 0 ) {
            seriesData.push(
                {
                    name: translation('team_hwi'),
                    data: props.hviValues[1],
                    color: '#3f3b33'
        
                }
            );
        }
    }

    const options = {
        chart: {
            type: 'spline',
            scrollablePlotArea: {
                minWidth: 600,
                scrollPositionX: 1
            },
            defaultSeriesType: 'column'
        },
        title: {
            text: `${props?.title ? props.title : translation('hvi_test_title')}`,
            align: 'center',
            y: 25,
            margin: 25
        },
        subtitle: {
            text: '',
            align: 'left'
        },
        xAxis: {
            tickInterval: 1,
            categories: props.dates
        },
        yAxis: {
            type: 'linear',
            min: 12,
            max: 72,
            categories: [0, 12, 20, 40, 60, 72],
            plotBands: [{ // Light air
                from: 0,
                to: 12,
                color: 'rgba(255,255,255,1)',
                label: {
                    text: '',
                    style: {
                        color: '#fff'
                    }
                }
            },
                { // Light air
                from: 12,
                to: 24,
                color: 'rgba(178, 55, 34, 0.8)',
                label: {
                    text: '',
                    style: {
                        color: '#fff'
                    }
                }
            }, { // Light breeze
                from: 24,
                to: 59,
                color: 'rgba(233, 185, 15, 0.8)',
                label: {
                    text: '',
                    style: {
                        color: '#f1c232'
                    }
                }
            }, { // Gentle breeze
                from: 59,
                to: 72,
                color: 'rgba(119, 132, 65, 0.8)',
                label: {
                    text: '',
                    style: {
                        color: '#6aa750'
                    }
                }
            }]
        },
        tooltip: {
            headerFormat: '<b>{series.name}</b><br />',
            formatter: function () {
                let returnFormat = `${translation('date')} = ${this.x}<br />HWI = ${this.y}`;

                //console.log( this.point.index );

                if ( props.summary &&  this.series?.name === translation('team_hwi') ) {
                    returnFormat = `${translation('week')} = ${this.x}<br />HWI: ${this.y} <br />${translation('number_of_answd')}: ${props.summary[this.point.index]?.items}`;
                }

                return returnFormat;
            },
        },
        plotOptions: {
            spline: {
                lineWidth: 3,
                states: {
                    hover: {
                        lineWidth: 4
                    }
                },
                marker: {
                    enabled: true
                }
            },
            series: {
                connectNulls: true
            }
            
        },
        series: seriesData,
        navigation: {
            menuItemStyle: {
                fontSize: '10px'
            }
        }
    }
    
    if (typeof Highcharts === 'object') {
        HighchartsExporting(Highcharts)
    }

    useEffect(() => {

        if ( hviUpdated ) return;

        if ( props.hviValues[1] && props.hviValues[1].length > 0 ) {

            const teamHviData = props.hviValues[1].filter( (el) => {
                return el != null;
            });
    
            if ( teamHviData.length > 0 ) {

                let itemKey;

                if ( team_id ) {
                    itemKey = `team_${team_id}`;
                } else if ( !team_id && organization_id ) {
                    itemKey = `org_${organization_id}`;
                }

                if ( itemKey ) {
                    dispatch( getHviData({[itemKey]: props.hviValues[1]}) );
                    setHviUpdated(true);
                }
            }
        } else {
            return;
        }
    
    
    }, [dispatch, props.hviValues, organization_id, team_id, hviUpdated]);

    //console.log( hvidata );

    return (
        <div className="hvi-chart-wrap mb-3">
            {props.loading &&
                <div className="d-flex align-items-center">
                    <div className="spinner-border spinner-border-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <h5 className="ps-2">{translation('processing_latest')}</h5>
                </div>
            }

            { ( props.dates && props.dates.length === 0 ) && (seriesData && seriesData.length === 0) && organization_id && props?.dataFetched &&
                <div className="row">
                    <div className="col-12">
                        <div className="alert alert-downriver" role="alert">
                            <div className="row align-items-center">
                                <div className="col-12 col-lg-8">
                                    { props.type === 'team' &&
                                        <span>{translation('no_hwi_team')}</span>
                                    }
                                </div>
                                <div className="col-12 col-lg-4 text-center">
                                    <Link to="/hvi/" className="btn btn-halite-blue rounded-pill px-4">
                                        <span className="pe-2">{translation('go_to_test')}</span>
                                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {props.dates.length > 0 && props.hviValues.length > 0 &&
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                />
            }

            { !props.dates.length > 0 && !seriesData.legth > 0 && !organization_id &&
                <div className="row">
                    <div className="col-12">
                        <div className="alert alert-downriver" role="alert">
                            <div className="row align-items-center">
                                <div className="col-12 col-lg-8">
                                    { props.type === 'personal' &&
                                        <span>{translation('no_hwi_data')}</span>
                                    }
                                    { props.type === 'team' &&
                                        <span>{translation('no_hwi_team')}</span>
                                    }
                                </div>
                                <div className="col-12 col-lg-4 text-center">
                                    <Link to="/hvi/" className="btn btn-halite-blue rounded-pill px-4">
                                        <span className="pe-2">{translation('go_to_test')}</span>
                                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default PersonalLinear;